import equalHeight from "../../equalHeight";

var scrollFlag = true;

export default function headerScrollControl() {
  equalHeight();
  window.addEventListener('scroll', function () {
    if (scrollFlag == true) {
      scrollFlag = false;
      equalHeight('.grid-view .product-list-holder .product_item-img');
    }
    if ($('.menu-active').length) {
      return;
    } else if ($(window).scrollTop() >= 40 && !($('.checkout-page').length)) {
      $('body').addClass('fixed-header');
    } else {
      $('body').removeClass('fixed-header');
    }

    if ($('.search_phrase.ui-autocomplete-input').length > 0) {
      var searchAutocompleteInput = $('.search_phrase.ui-autocomplete-input').offset().top;

      if ($(window).scrollTop() <= 40) {
        $('.ui-menu.ui-widget.ui-autocomplete').css({
          top: searchAutocompleteInput + 40
        });

      } else if (window.innerWidth > 824 && window.innerWidth < 1025) {
        $('.ui-menu.ui-widget.ui-autocomplete').css({
          top: 107
        });
      } else if (window.innerWidth < 824 && window.innerHeight > 412) {
        $('.ui-menu.ui-widget.ui-autocomplete').css({
          top: 151
        });
      }
    }
  }, { passive: true });
}